export default function PHP_Quiz() {
  return (
    <div>
      <h1>PHP_Quiz</h1>
    </div>
  );
}
